import { render, staticRenderFns } from "./WebsiteGoodsInquire.vue?vue&type=template&id=691d570c&scoped=true&"
import script from "./WebsiteGoodsInquire.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsInquire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691d570c",
  null
  
)

export default component.exports